export function snakeToCamel(value: string): string {
  return value.replace(/_(\w)/g, m => m[1].toUpperCase());
}

export function getFieldId(label: string): string {
  return `${label.replace(/[^a-zA-Z]/g, '_')}__${Math.floor(Math.random() * 100)}`;
}

export function rgba(r: number, g: number, b: number, a: number = 1): string {
  return `rgba(${r},${g},${b},${a})`;
}
